﻿import {Message} from "@2d-front-monorepo/design-library";
import {Attachments, ICreateComponentAttachments} from "@2d-front-monorepo/permits-business";

import {JSX, useCallback, useMemo} from "react";
import {useNavigate, useParams} from "react-router";
import UpdateAttachmentsComponent from "../../components/UpdateAttachmentsComponent";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

export default function DocumentUpdate(): JSX.Element {
	const {documentId} = useParams();
	const {permits} = usePermits();
	const navigate = useNavigate();
	const documents = useMemo(() => Attachments.list(permits), [permits]);
	const document = documents.find(x => x.attachment.id === documentId);
	const initialState = useMemo<ICreateComponentAttachments>(() => ({
		attachments: {}
	}), []);

	if (document == null) {
		return <Message title={{text: `Invalid document id: [${documentId}]`}} type="error"/>;
	}

	const onSubmit = useCallback(async function (): Promise<void> {
		navigate(PrivateRoutes.documents);
	}, [document]);

	return <UpdateAttachmentsComponent attachments={[document.attachment]} onSubmit={onSubmit} initialState={initialState}/>;
}
